import * as ActionTypes from './types';

function calculatePage(pageSize, pageNumber, totalCount, startIndex) {
    if (pageSize === 0) { return { totalPages: 0 }; }
    const firstItem = startIndex + 1;
    let lastItem = startIndex + pageSize - 1;
    if (lastItem >= totalCount) { lastItem = totalCount; }
    return {
        firstItem,
        lastItem,
        totalPages: Math.ceil(totalCount / pageSize)
    };
}

function calculateStartIndex(pageSize, pageNumber, totalCount) {
    let startIndex = (pageSize * pageNumber) + 1;
    if (startIndex === 0) { startIndex = 1; }
    if (startIndex >= totalCount) { startIndex = totalCount; }
    return { startIndex };
}

export default {
    [ActionTypes.DATA_SEARCH]: (state, { search }) => ({
        ...state,
        search
    }),

    [ActionTypes.TICKET_CHECKBOX_ARRAY]: (state, { ticketCheckboxArray }) => ({
        ...state,
        ticketCheckboxArray
    }),

    [ActionTypes.LOAD_DATA]: (state, {
        startIndex,
        pageSize,
        filter,
        sortColumn,
        sortDirection,
        requestForId,
        advanceSearch,
        sortOrders,
        ticketsData,
        totalCount,
        pageCount,
        pageNumber,
        showErrorMessage,
        errorMessage,
        errorTitle,
        showLoginErrorMessage,
        tabsData,
        elapsed,
        startTime
    }) => ({
        ...state,
        ...calculatePage(pageSize, pageNumber, totalCount, startIndex),

        startIndex,
        pageSize,
        filter,
        sortColumn,
        sortDirection,
        requestForId,
        advanceSearch,
        sortOrders,
        ticketsData,
        totalCount,
        pageCount,
        pageNumber,
        showErrorMessage,
        errorMessage,
        errorTitle,
        showLoginErrorMessage,
        tabsData,
        elapsed,
        startTime
    }),

    [ActionTypes.LOAD_USER_DATA]: (state, { requestForId, tabsData }) => ({
        ...state,
        requestForId,
        tabsData
    }),

    [ActionTypes.LOAD_OWNERTEAM_DATA]: (state, { OwnerTeamData }) => ({
        ...state,
        OwnerTeamData
    }),

    [ActionTypes.LOAD_CELL_DATA]: (state, { CellData }) => ({
        ...state,
        CellData
    }),

    [ActionTypes.LOAD_TICKETCATEGORY_DATA]: (state,
        { ticketCategoryData, refreshCategoryGridTime }) => ({
            ...state,
            ticketCategoryData,
            refreshCategoryGridTime
        }),

    [ActionTypes.LOAD_TICKET_DATA]: (state, { TicketPlayStatusData }) => ({
        ...state,
        TicketPlayStatusData
    }),

    [ActionTypes.CHANGE_OWNER_TEAM]: (state, { UserDetails }) => ({
        ...state,
        UserDetails
    }),

    [ActionTypes.LOAD_TECH_DATA]: (state, { TechStatusData }) => ({
        ...state,
        TechStatusData
    }),

    [ActionTypes.LOAD_LASTUPDATEDDATE]: (state, { LastUpdatedDate }) => ({
        ...state,
        LastUpdatedDate
    }),

    [ActionTypes.LOAD_EMPTY_DATA]: (state, { ticketsData }) => ({
        ...state,
        ticketsData
    }),

    [ActionTypes.TOGGLE_MENU]: (state, { columnFilters }) => ({
        ...state,
        columnFilters
    }),

    [ActionTypes.PAGE_NUMBER_CHANGE]: (state, { pageNumber, footerPosition }) => ({
        ...state,
        ...calculatePage(state.pageSize, pageNumber, state.totalCount, state.startIndex),
        pageNumber,
        footerPosition
    }),

    [ActionTypes.UPDATE_START_INDEX]: state => ({
        ...state,
        ...calculateStartIndex(state.pageSize, state.pageNumber, state.totalCount)
    }),

    [ActionTypes.LOAD_ENCDATA]: (state, { Enckey }) => ({
        ...state,
        Enckey
    }),

    [ActionTypes.LOAD_ERROR_MESSSAGE]: (state,
        { showErrorMessage, showLoginError, errorMessage, errorTitle }) => ({
            ...state,
            showErrorMessage,
            showLoginError,
            errorMessage,
            errorTitle
        }),

    [ActionTypes.ON_CHECK_FILTER_COLUMN]: (state,
        { requestForId, tabsData, filterPreviousData, isFilterChecked }) => ({
            ...state,
            requestForId,
            tabsData,
            filterPreviousData,
            isFilterChecked
        }),


    [ActionTypes.SAVE_NEWTAB]: (state, { tabsData, errors, requestForId, startTime, elapsed }) => ({
        ...state,
        tabsData,
        errors,
        requestForId,
        startTime,
        elapsed
    }),

    [ActionTypes.REMOVE_TAB]: (state, { tabsData, requestForId }) => ({
        ...state,
        tabsData,
        requestForId
    }),

    [ActionTypes.SWAP_TAB]: (state, { tabsData, requestForId, columnFilters }) => ({
        ...state,
        tabsData,
        requestForId,
        columnFilters
    }),

    [ActionTypes.CLEAR_ERRORS]: (state, { errors }) => ({
        ...state,
        errors
    }),

    [ActionTypes.EDIT_TAB]: (state, { tabsData, errors }) => ({
        ...state,
        tabsData,
        errors
    }),


    [ActionTypes.SET_ELAPSED_TIME]: (state, { elapsed }) => ({
        ...state,
        elapsed
    }),

    [ActionTypes.PRINT_TICKET]: (state, { UserDetails }) => ({
        ...state,
        UserDetails
    }),

    [ActionTypes.CLEAR_FILTERS]: (state, { advanceSearch }) => ({
        ...state,
        advanceSearch
    }),

    [ActionTypes.SHOW_HIDE_LOADER]: (state, { dataRequestsTokens }) => ({
        ...state,
        dataRequestsTokens
    }),

    [ActionTypes.START_RESET_TIMER]: (state, { timerDetails }) => ({
        ...state,
        timerDetails
    }),

    [ActionTypes.SAVE_FILTER_INFO]: (state, { filterPreviousData, tabsData }) => ({
        ...state,
        filterPreviousData,
        tabsData
    }),

    [ActionTypes.UNDO_FILTER_INFO]: (state, { tabsData, filterPreviousData }) => ({
        ...state,
        tabsData,
        filterPreviousData
    })
};



// WEBPACK FOOTER //
// ./app/tickets/reducers.jsx